import { FieldLabel } from './ui/field';

export const RequiredLabel = ({ children, ...props }) => {
  return (
    <FieldLabel {...props}>
      {children} <span className="text-destructive">*</span>
    </FieldLabel>
  );
};
